import React from 'react';
import TauriNavigation from '../TauriNavigation/TauriNavigation';
import 'bootstrap/dist/css/bootstrap.min.css';
import './TauriLayout.css';
import OpalRadialMenu from '../OpalRadialMenu/OpalRadialMenu';

const TauriLayout = ({ children }) => {

  return (
    <div className='layout'>
      <TauriNavigation />

      <div className="container-fluid">
        {children}
      </div>

      <OpalRadialMenu />;
    </div>
  );
};

export default TauriLayout;
